"use strict";

exports.__esModule = true;
exports.default = void 0;
var _isDOMElement = _interopRequireDefault(require("./isDOMElement.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function findDOMElement(element, context) {
  if (context === void 0) {
    context = document;
  }
  if (typeof element === 'string') {
    return context.querySelector(element);
  }
  if ((0, _isDOMElement.default)(element)) {
    return element;
  }
  return null;
}
var _default = exports.default = findDOMElement;